import React from 'react';

interface InputBoxProperties {
  label: string;
  placeholder?: string;
  type: string;
  value: string;
  name: string;
  onChange: (name: string, value: string | number) => void;
  icon?: React.ReactNode; // Optional icon
  className?: string; // Optional class for additional styling
  readonly?: boolean;
  disallowNegative?: boolean;
}
/**
 * params
 * @param param0
 * @returns
 */
function InputBox({
  label,
  placeholder,
  value,
  onChange,
  icon,
  name,
  className,
  type,
  readonly,
  disallowNegative,
}: InputBoxProperties) {
  /**
   * rules
   * @param changeValue
   */
  const handleValueChange = (changeValue: string | number) => {
    let finalValue = changeValue;
    if (type === 'number' && disallowNegative) {
      if (typeof finalValue === 'string') {
        const numericValue = Number(finalValue);
        if (numericValue < 0) {
          finalValue = finalValue.replace('-', '');
        }
      } else if (typeof finalValue === 'number' && finalValue < 0) {
        finalValue = 0;
      }
    }
    onChange(name, finalValue);
  };

  return (
    <div className={`input-box ${className}`}>
      <span className="input-label">{icon && <span className="input-icon">{icon}</span>}</span>
      <input
        type={type}
        value={value}
        onChange={(event) => handleValueChange(event.target.value)}
        className="input-field"
        readOnly={readonly}
        min={disallowNegative && type === 'number' ? 0 : undefined}
        required
      />
      <span className={value === '' ? 'input-placeholder' : 'input-placeholder-hover'}>
        {placeholder}
      </span>
      <span className="input-label-value">{label}</span>
    </div>
  );
}
InputBox.defaultProps = {
  placeholder: '', // Default placeholder
  icon: null, // Default icon
  className: '',
  readonly: false,
  disallowNegative: false,
};

export default InputBox;
